import * as yup from 'yup';
import * as cardValidator from 'card-validator';

const CardFormSchema = yup.object().shape({
  expiration_date: yup.string()
    .test('invalid', 'Invalid expiration date', (value, context) => {
      const { month, year } = context.parent;
      return cardValidator.expirationDate(`${month}/${year}`).isValid;
    }),
  verification: yup.string()
    .required()
    .test((value, context) => {
      const { number } = context.parent;
      const cardBrand = cardValidator.number(number).card?.type;
      const maxLength = (cardBrand === 'american-express') ? 4 : 3;
      return cardValidator.cvv(value, maxLength).isValid;
    }),
  number: yup.string()
    .required()
    .test((value) => cardValidator.number(value).isValid)
});

export default CardFormSchema;
